import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_MEMBER_REPORT_PRINT_FILE_REQUEST: '',
  GET_MEMBER_REPORT_PRINT_FILE_SUCCESS: '',
  GET_MEMBER_REPORT_PRINT_FILE_FAILURE: '',

  GET_MEMBER_REPORT_EXCEL_FILE_REQUEST: '',
  GET_MEMBER_REPORT_EXCEL_FILE_SUCCESS: '',
  GET_MEMBER_REPORT_EXCEL_FILE_FAILURE: '',

};

types = setStoreTypeValues(types, 'appMemberReports');

export default types;
